import styled from 'styled-components';

export const DeleteBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > p {
    margin: 0;
    font-size: 14px;
    line-height: 1.55;
    color: ${({ theme: { colors = {} } }) =>
      colors.onSurfaceVariant ?? '#A1A3B8'};
  }
`;

export const ProcessName = styled.strong`
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
`;
